import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatosEmpresa } from '../../models/DatosEmpresa';
import { EmpresaService } from '../../components/asistencia-mail/services/empresa.service';
import { Contexto } from '../../models/contexto';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-selector-empresa',
  templateUrl: './selector-empresa.component.html',
  styleUrls: ['./selector-empresa.component.scss']
})
export class SelectorEmpresaComponent {
  @Input() public ctx: Contexto;
  @Input() buscador: boolean = false;
  @Input() empresas: DatosEmpresa[] = []
  @Input() empresasOriginales: DatosEmpresa[] = []
  @Input() persIdentificador: string

  empresaSeleccionada: DatosEmpresa = null;
  opcionesEmpresa: { value: string; texto: string }[] = [
    { value: 'contrib', texto: 'N°. contribuyente' },
    { value: 'emp', texto: 'N°. empresa' }
  ];
  tipoFiltro: string = "contrib";
  parametroFiltro: string = "";
  busquedaRealizada: boolean = false;
  errorValidacion: boolean = false;
  mensajeError: string = "";


  @Output() seleccionEmpresa = new EventEmitter<DatosEmpresa>();

  constructor(
    public rest: EmpresaService) {

  }

  setEmpresa(empresa: DatosEmpresa) {
    this.empresaSeleccionada = empresa;
  }

  selecionarEmpresa() {
    this.seleccionEmpresa.emit(this.empresaSeleccionada);
  }

  realizarBusqueda() {
    this.errorValidacion = false;
    this.mensajeError = "";
    this.empresas = [];
    this.setEmpresa(null)
    if (this.tipoFiltro == undefined || this.tipoFiltro === 'undefined') {
      this.tipoFiltro = "emp";
    }
    //this.empresasOriginales=[];
    // Filtrar empresas según el tipo de dato y el filtro proporcionado
    this.empresas = this.empresasOriginales.filter((c) => {
      return (
        (this.tipoFiltro === "contrib" && this.parametroFiltro.trim() === c.nroContribuyente.trim()) ||
        (this.tipoFiltro === "emp" && this.parametroFiltro.trim() === c.nroEmpresa.trim())
      );
    }
    );

    if (this.empresas.length == 0) {
      const datos = {
        idAsistente:this.ctx.idAsistente,
        idNodo:this.ctx.idNodo,
        tipo:this.tipoFiltro,
        dato:this.parametroFiltro,
        persId:this.persIdentificador
      }
      this.rest.cargarDatosEmpresa(datos).pipe(take(1)).subscribe(
        (respuesta: any) => {
          //console.log(respuesta.data);
          if (respuesta && respuesta.status === 'success' ) {
            if (respuesta.content && respuesta.content.length > 0) {
              this.empresas = respuesta.content;
              this.busquedaRealizada = true;
            } else {
              this.errorValidacion = true;
              this.mensajeError = respuesta.mensajeValidacion;
            }
          }
        },
        err => {
          console.error(err);
          alert("Error inesperado en la carga de datos del usuario");
        });
    } else {
      this.busquedaRealizada = true;
    }
  }

  obtenerPlaceHolderFiltro() {
    let placeholder = "Seleccione tipo de filtro";
    let opcionFiltro = this.opcionesEmpresa.find(x => x.value == this.tipoFiltro);
    if (opcionFiltro) {
      placeholder = "Filtrar por " + opcionFiltro.texto?.toLocaleLowerCase();
    }
    return placeholder;
  }
}

